import styled from 'styled-components'
import { colors } from '../utils/config'
import {
  DynamicContentType,
  youtubeUrl,
  YtVideoData,
} from '@bm-js/atlascloud-shared'

const StyledYTVideoContent = styled.div`
  .error-container {
    background: ${colors.blackAlpla300};
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-weight: 500;
      font-size: 1.4rem;
      color: ${colors.primary400};
      margin-bottom: 6rem;
    }
  }
  .iframe-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    margin-bottom: 2rem;
  }
  .iframe-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

type Props = {
  content: DynamicContentType<YtVideoData>
}

const YTVideoContent = ({ content }: Props) => {
  const { url } = content.data
  const ytId = youtubeUrl(url)
  const parsedUrl = `https://www.youtube.com/embed/${ytId}`
  return (
    <StyledYTVideoContent>
      <div
        className='iframe-container'
        style={{
          marginBottom: content.data.marginBottom,
        }}
      >
        <iframe
          width='1920'
          height='1080'
          src={parsedUrl}
          title='YouTube video player'
          frameBorder='0'
          allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        ></iframe>
        {!ytId && (
          <div className='error-container'>
            <p className='m0'>Felaktig länk</p>
          </div>
        )}
      </div>
    </StyledYTVideoContent>
  )
}

export default YTVideoContent
